import {
  TermsAndCondition,
  faqs,
  howItWorks,
  purchaseGiftCardLanguages,
  redeemGiftCardLanguages,
  DBacksStandaloneTermsAndConditions,
} from "./helpers";
import { routes } from "@/global/routes";
import SeatMap3dPreview from "public/images/diamondbacks/seat_map_preview.png";
import BackgroundImage from "public/images/diamondbacks/dbacks_bg.jpeg";
import BannerImage from "public/images/diamondbacks/dbacks_bg.jpeg";
import { vendorUUIDs } from "../../constants";

const LogoImage =
  "https://ss-leagues.s3.amazonaws.com/AZDBacks%20Assets/diamondbacks_logo_march_22.png";

const config = {
  teamSchema: "flex_sandbox_gift",
  browserTitle: "Arizona Diamondbacks",
  packages: false,
  defaultRoute: routes.purchaseSeats,
  phoneNumber: "",
  teamName: "Flex Sandbox",

  // seat map configs
  seatMapConfigs: {
    venueId: "nam-us-10167-diamondbacks-sec",
    mapId: "blockmap2d",
  },

  // gift cards
  giftCardConfigs: {
    isMenuGiftCardEnabled: true,
    isLandingPageGiftCardEnabled: false,
    isStandalonePageGiftCardEnabled: true,
    redirectGiftCardUrl: routes.redeem,
  },

  // disabled routes
  disabledRoutes: [],

  // switches
  checkoutCreditPackages: false,
  availableCreditEnabled: true,
  isCrowdHandlerEnabled: false,
  inventoryType: "SECTION-LEVEL",

  // purchase seats config
  purchaseSeatConfigs: {
    minGameSelectionCount: 3,
    minSeatLimit: 1,
    isSimilarSeatForAllEvents: false,
    allowManualCartInSimilar: false,
    isCheckoutEditSeatsEnabled: false,
    isDiffSeatAlertEnabled: false,
  },

  refreshInventoryWhenEventClick: false,
  platform: vendorUUIDs.ticketmaster,
  oktaIssuer: "",
  oktaClientId: "",
  isSaveCardAllowed: true,

  // feature configs
  packageConfigs: {
    isPackageEnabled: false,
    canRemovePackageGames: false,
    staticBuildYourOwn: null,
  },

  // purchase credit configs
  purchaseCreditConfigs: {
    isLandingPurchaseCreditEnabled: false,
    isStandAlonePurchaseCreditEnabled: false,
    showPurchaseCreditLinkInHomeMenu: false,
    isPurchaseCreditHistoryEnabled: false,
  },

  // intercom settings
  intercomConfigs: {
    isIntercomEnabled: true,
    allowedPages: [],
  },

  // checkout validations
  checkoutValidation: {
    allowedZipFailCount: Infinity,
    allowedPaymentFailCount: Infinity,
  },

  // analytics configs
  analyticsConfigs: {
    googleAnalyticsId: "",
    attrkPixelId: "",
    beaconId: "",
  },

  // redirect configs
  redirectConfigs: {
    internalRedirectUrl: "",
    externalRedirectUrl: "",
  },

  // urls
  accountManagerUrl: "https://am.ticketmaster.com/azdbacks",

  // images
  images: {
    findGamesBannerImage: BannerImage.src,
    authBackgroundImage: BackgroundImage.src,
    checkoutStatusPageImage: BackgroundImage.src,
    giftCardStandalonePageImage: BannerImage.src,
    logoImage: LogoImage + "?width=84&height=66",
    logoNameImage: "",
    faviconImage: LogoImage,
    seatMap3dPreviewImage: SeatMap3dPreview.src,
  },

  uiConfigs: {
    bannerImage: {
      title: "Choose Your Games",
      isBackgroundBasedBanner: true,
    },

    featuredGameCard: {
      showLogoWithTitle: false,
      hideOverlayLogo: true,
    },
    bottomBar: {
      showGameSelectionProgress: true,
    },
  },

  colors: {
    primary: "#AA182C",
  },

  howItWorks: howItWorks,
  faqs: faqs,

  languages: {
    topNavMenuItems: "", // can be react node as well
    checkoutTermsAndCondition: <TermsAndCondition />,
    registrationTermsAndCondition: <TermsAndCondition />,
    purchaseSeats: null,
    purchaseGiftCard: purchaseGiftCardLanguages,
    redeemGiftCard: redeemGiftCardLanguages,
    standaloneTermsAndConditions: <DBacksStandaloneTermsAndConditions />,

    giftCard: {
      title: "Give The Gift Of Broadway",
      createGiftCard: {
        description:
          "Share the magic of Broadway with a friend or loved one. Upon purchase of a gift card, a unique code will be generated for the intended recipient to redeem. Once redeemed, the gift card is not refundable.",
        recipient: {
          sendNowFalse: {
            description:
              "If an intended recipient is not specified, once purchased, you will have to forward the unique code to the recipient. Upon your recipient receiving their gift card, they will be prompted to enter their unique code to redeem the gift card. Once redeemed, the recipient will receive an account credit that they can use to purchase tickets for all Hippodrome Broadway Series shows in Baltimore.",
          },
          sendNowTrue: {
            description:
              "The Recipient will be sent an email with the unique code for them to redeem their gift card. Once redeemed, the recipient will receive an account credit that they can use to purchase tickets for all Hippodrome Broadway Series shows in Baltimore.",
          },
        },
      },
      redeemGiftCard: {
        loggedIn: {
          description:
            "Please input the case sensitive code provided to redeem the value of the gift card to the Hippodrome Broadway Series in Baltimore account above.",
        },
        logout: {
          description:
            "Please input the case sensitive code provided to redeem the value of the gift card to the Hippodrome Broadway Series in Baltimore.",
        },
        success: {
          description:
            "has been added to your Hippodrome Broadway Series in Baltimore Account Manager account!",
        },
      },
    },

    signInAuthText:
      "Connect your Ticketmaster account to continue with seamless access.",
  },
};

export default config;
